var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 20,
    height: 20,
    transform: "translate(4.291 4.29)",
    fill: "#012169",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(-4.291 -4.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_639",
    "data-name": "Mask Group 639",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "spotify",
    d: "M10,.323a10,10,0,1,0,10,10A10,10,0,0,0,10,.323Zm4.06,14.714a.769.769,0,0,1-.431-.145A11.381,11.381,0,0,0,5.294,13.9a2.6,2.6,0,0,1-.48.1.628.628,0,0,1-.637-.637.639.639,0,0,1,.548-.677c3.3-.73,6.677-.665,9.556,1.056a.682.682,0,0,1,.391.665.609.609,0,0,1-.613.621Zm1.085-2.645a1,1,0,0,1-.5-.169,13.067,13.067,0,0,0-9.621-1.185,1.661,1.661,0,0,1-.48.1.783.783,0,0,1-.782-.782.793.793,0,0,1,.625-.835,13.563,13.563,0,0,1,3.944-.548,14.115,14.115,0,0,1,7.137,1.835.841.841,0,0,1,.456.794A.781.781,0,0,1,15.145,12.391ZM16.4,9.319a.927.927,0,0,1-.52-.157c-2.871-1.714-8-2.125-11.327-1.2a1.915,1.915,0,0,1-.52.1.931.931,0,0,1-.94-.952.953.953,0,0,1,.7-.964A16.9,16.9,0,0,1,8.528,5.54,17.03,17.03,0,0,1,16.81,7.468a.947.947,0,0,1,.52.911.934.934,0,0,1-.935.94Z",
    transform: "translate(4.291 3.968)",
    fill: "#012169"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare3);
export default __webpack_public_path__ + "static/media/share3.5a38964b9ae7cb4616a635f7fabdc4de.svg";
export { ForwardRef as ReactComponent };